import React, { useCallback, useEffect, useMemo } from 'react'
import { MdEdit } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import * as reducks from '../../../reducks'
import routes from '../../../config/routes'
import history from '../../../lib/history'
import Flex from '../../commons/Flex/Flex'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import TimelineFilters from './TimelineFilters'
import Text from '../../commons/Text/Text'
import Equalizer from '../../commons/Icons/Equalizer'
import Timeline from '../../commons/Timeline/Timeline'
import LoadingBounce from '../../commons/LoadingBounce/LoadingBounce'
import WomanHistory from '../../commons/Ilustrations/WomanHistory'
import styles from './timelineContainer.module.scss'

const HistoryContainer = () => {
  const dispatch = useDispatch()

  const timelineReducer = useSelector((state) => state.timelineReducer)
  const {
    pagination: {
      content: { currentPage, lastPage, total }
    }
  } = timelineReducer

  const empty = useMemo(
    () => !timelineReducer.list.length,
    [timelineReducer.list]
  )

  const hasPages = useMemo(
    () => currentPage !== lastPage,
    [currentPage, lastPage]
  )

  useEffect(() => {
    dispatch(reducks.resources.timeline.actions.getTimeline())
  }, [])

  const handlePagination = useCallback(() => {
    if (currentPage > lastPage) return null

    return dispatch(
      reducks.resources.timeline.actions.getTimeline({
        page: currentPage + 1,
        increment: true
      })
    )
  }, [currentPage, lastPage])

  return (
    <DefaultLayout>
      <Flex column>
        <Text
          size="lg"
          color="gray"
          variation="dark"
          extraBold
          lineHeight="30px"
        >
          Histórico de atividades
        </Text>

        <TimelineFilters />

        <div className={styles.layout}>
          <div className={styles.timeline}>
            {timelineReducer.list.length > 0 &&
              timelineReducer.list.map((item) => (
                <Timeline
                  key={item.date}
                  date={item.date}
                  events={item.events}
                />
              ))}

            {timelineReducer.fetching && (
              <div style={{ padding: 45, textAlign: 'center' }}>
                <LoadingBounce />
              </div>
            )}

            {hasPages &&
              !timelineReducer.fetching &&
              (!timelineReducer.fetching ||
                !timelineReducer.pagination.fetching) && (
                <div className={styles.pagination}>
                  <button
                    type="button"
                    onClick={handlePagination}
                    className={styles.actionWhite}
                  >
                    <Text
                      font="custom"
                      color="gray"
                      variation="dark"
                      size="xs"
                      fontWeight="600"
                      lineHeight="20px"
                      value="ver mais"
                    />
                  </button>
                </div>
              )}

            {empty && timelineReducer.receive && (
              <div className={styles.empty}>
                <WomanHistory />
                <Text
                  value="Histórico"
                  extraBold
                  size="lg"
                  lineHeight="28px"
                  color="gray"
                  variation="dark"
                  margin="40px 0px 16px 0px"
                />
                <Text
                  value="Você ainda não escreveu nenhuma atividade no seu histórico."
                  size="xs"
                  lineHeight="24px"
                  color="gray"
                  font="custom"
                  fontWeight="400"
                  className={styles.textCenter}
                />
              </div>
            )}
          </div>
          <div className={styles.actions}>
            <div className={styles.amountCard}>
              <Flex
                alignItems="center"
                justifyContent="space-between"
                width="100%"
              >
                <Flex column justifyContent="center">
                  <Text
                    size="mlg"
                    font="custom"
                    extraBold
                    lineHeight="32px"
                    color="white"
                  >
                    {total > 0 ? total : '0'}
                  </Text>
                  <Text
                    size="xs"
                    font="custom"
                    lineHeight="18px"
                    fontWeight="400"
                    color="gray"
                    variation="lightest"
                  >
                    Interações no período
                  </Text>
                </Flex>
                <Equalizer />
              </Flex>
            </div>
            <div className={styles.cardAction}>
              <Text
                color="gray"
                variation="dark"
                size="mlg"
                extraBold
                margin="0px 0px 16px 0px"
              >
                Interação
              </Text>
              <Text
                color="gray"
                size="sm"
                lineHeight="26px"
                font="custom"
                margin="0px 0px 24px 0px"
                fontWeight="400"
                style={{ textAlign: 'justify' }}
              >
                Analise e registre as interações com seu cliente e crie a melhor
                estratégia de atendimento.
              </Text>
              <button
                type="button"
                className={styles.cardActionButton}
                onClick={() => history.push(routes.timelineForm.path)}
              >
                <Text
                  size="xs"
                  color="gray"
                  variation="lightest"
                  margin="0px 10px 0px 0px"
                >
                  Escrever
                </Text>
                <MdEdit color="white" />
              </button>
            </div>
          </div>
        </div>
      </Flex>
    </DefaultLayout>
  )
}

HistoryContainer.defaultProps = {
  params: PropTypes.shape({
    search: PropTypes.string
  })
}

export default HistoryContainer
